import React from 'react';
import { connect } from 'react-redux';
import { staticsUrl, baseUrl } from '../../../config';
import Player from './Player';
import PreloadImages from '../../../components/PreloadImages';
import historyCache from '../../../config/historyCache.json';

// eslint-disable-next-line
let lastFile = '';

class Drama extends React.Component {
  state = {
    file: '',
    status: 'paused',
    thumbs: [],
    progress: 0,
  };
  soundEnabled = true;

  componentDidMount() {
    const { playing, waiting, ended, pause } = this.props.media.events;
    this.setState({ playingSubscribtion: playing.subscribe(this.soundPlaying) });
    this.setState({ loadingSubscribtion: waiting.subscribe(this.soundLoading) });
    this.setState({ endedSubscribtion: ended.subscribe(this.soundFinished) });
    this.setState({ pausedSubscribtion: pause.subscribe(this.soundPaused) });
    const exercise = this.props.exerciseProps?.exercise;
    if (exercise) {
      const images = exercise.map(r => r.imageUrl);
      const thumbs = [];
      images.forEach(img => {
        const preImg = historyCache[img];
        if (preImg) {
          const url = `${baseUrl}/resources/History/${preImg}`;
          if (thumbs.indexOf(url) === -1) thumbs.push(url);
        }
      });
      this.setState({ thumbs });
    }
  }

  componentWillUnmount() {
    this.state.playingSubscribtion.unsubscribe();
    this.state.loadingSubscribtion.unsubscribe();
    this.state.endedSubscribtion.unsubscribe();
    this.state.pausedSubscribtion.unsubscribe();
    this.stop();
  }

  play = (file) => {
    if (!file || !this.soundEnabled) return;
    const url = staticsUrl + file;
    this.setState({ file });
    this.props.media.play(url);
    lastFile = file;
  }

  stop = () => {
    this.props.media.stop();
  }

  soundLoading = () => this.setState({ status: 'loading' });
  soundPlaying = () => this.setState({ status: 'playing' });
  soundFinished = () => { }
  soundPaused = () => this.setState({ status: 'paused' });
  setSoundEnabled = (val) => this.soundEnabled = val;

  render() {
    return (
      <>
        <PreloadImages images={this.state.thumbs} onImgLoad={(progress) => this.setState({ progress })} />
        <Player
          play={this.play}
          stop={this.stop}
          status={this.state.status}
          {...this.props.exerciseProps}
          progress={this.state.progress}
          setSoundEnabled={this.setSoundEnabled}
          soundEnabled={this.soundEnabled}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    media: state.media,
  };
}

export default connect(mapStateToProps)(Drama);
